import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { DatePipe } from '@angular/common';
import { routing, appRoutingProviders } from './app.routing';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { AlertModule } from 'ngx-bootstrap/alert';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { NgSelectModule } from '@ng-select/ng-select';

import { AppComponent } from './app.component';
import { PrincipalComponent } from './components/principal/principal.component';
import { OrdenproduccionComponent } from './components/ordenproduccion/ordenproduccion.component';
import { IngresoproduccionComponent } from './components/ingresoproduccion/ingresoproduccion.component';
import { ControlproduccionComponent } from './components/controlproduccion/controlproduccion.component';
import { LotesComponent } from './components/lotes/lotes.component';
import { EmpaquesComponent } from './components/empaques/empaques.component';
import { BloqueosComponent } from './components/bloqueos/bloqueos.component';
import { PackinglistComponent } from './components/packinglist/packinglist.component';
import { VencimientosComponent } from './components/vencimientos/vencimientos.component';
import { ProductosComponent } from './components/productos/productos.component';
import { StockComponent } from './components/stock/stock.component';
import { CapacidadComponent } from './components/capacidad/capacidad.component';
import { PalletsComponent } from './components/pallets/pallets.component';
import { InventariosComponent } from './components/inventarios/inventarios.component';
import { MovimientosComponent } from './components/movimientos/movimientos.component';
import { FichasComponent } from './components/fichas/fichas.component';
import { TratosComponent } from './components/tratos/tratos.component';
import { EstadisticaComponent } from './components/estadistica/estadistica.component';
import { ClientesComponent } from './components/clientes/clientes.component';
import { ProveedoresComponent } from './components/proveedores/proveedores.component';
import { DespachosComponent } from './components/despachos/despachos.component';
import { ReportesComponent } from './components/reportes/reportes.component';
import { PerfilComponent } from './components/perfil/perfil.component';
import { SalirComponent } from './components/salir/salir.component';
import { PermisosComponent } from './components/permisos/permisos.component';
import { PanelcontrolComponent } from './components/panelcontrol/panelcontrol.component';
import { PaginatorComponent } from './components/shared/paginator.component';
import { AdminTableComponent } from './components/shared/admin-table.component';
import { StockHistoricoComponent } from './components/stock-historico/stock-historico.component';
import { EspecificacionComponent } from './components/especificacion/especificacion.component';
import { TagsComponent } from './components/tags/tags.component';
import { PackingEcComponent } from './components/packing-ec/packing-ec.component';
import { EntradasComponent } from './components/entradas/entradas.component';
import { SalidasComponent } from './components/salidas/salidas.component';
import { QRCodeModule } from 'angularx-qrcode';
import { DesconcheComponent } from './components/desconche/desconche.component';
import { UnionsaldoComponent } from './components/unionsaldo/unionsaldo.component';
import { ReimprimiretiquetaComponent } from './components/reimprimiretiqueta/reimprimiretiqueta.component';
import { ReimprimirpalletComponent } from './components/reimprimirpallet/reimprimirpallet.component';
import { DevolucionComponent } from './components/devolucion/devolucion.component';
import { SolicitudmovimientoComponent } from './components/solicitudmovimiento/solicitudmovimiento.component';
import { EditComponent } from './components/solicitudmovimiento/edit/edit.component';
import { DetailComponent } from './components/solicitudmovimiento/detail/detail.component';
import { OrdenespendientesComponent } from './components/ordenespendientes/ordenespendientes.component';
import { RevisionorderComponent } from './components/revisionorder/revisionorder.component';
import { MessageComponent } from './components/message/message.component';
import { StocknodisponibleComponent } from './components/stocknodisponible/stocknodisponible.component';
import { StockcomercialComponent } from './components/stockcomercial/stockcomercial.component';
import { RendimientoComponent } from './components/rendimiento/rendimiento.component';

import { NG_SELECT_DEFAULT_CONFIG } from '@ng-select/ng-select';

//Services
import { ProveedoresService } from './services/providers.service';
import { ClientsService } from './services/clients.service';
import { GlobalService } from './services/global.service';
import { ProductionOrderService } from './services/productionOrders.service';
import { StockService } from './services/stock.service';
import { LoadService } from './services/load.service';
import { AuthService } from './services/auth.service';
import { CountriesService } from './services/countries.service';
import { ProductsService } from './services/products.service';
import { EspecificationService } from './services/especification.service';
import { LotesService } from './services/lotes.service';
import { ClientsSpecificationsService } from './services/clientsSpecifications.service';
import { SpeciesService } from './services/species.service';
import { ProductionOrderProductsService } from './services/productionOrdersProducts.service';
import { TagsService } from './services/tags.service';
import { PackingEcService } from './services/packingec.service';
import { ProductsPropertiesService } from './services/productProperties.service';
import { LocationService } from './services/location.service';
import { PalletsService } from './services/pallets.service';
import { FilterUrlService } from './services/filter-url.service';
import { UsersService } from './services/users.service';
import { InventoryService } from './services/inventory.service';
import { CodigosSernapescaService } from './services/codigos-sernapesca.service';
import { AreasService } from './services/areas.service';
import { OrdensalidaService } from './services/ordensalida.service';
import { OrderstatusService } from './services/orderstatus.service';
import { RendimientoService} from './services/rendimiento.service';


//Pipes
import { KeysPipe } from './pipes/keys.pipe';
import { SignupComponent } from './auth/signup/signup.component';
import { SigninComponent } from './auth/signin/signin.component';

//Interceptor
import { AuthInterceptor } from './interceptor/auth-interceptor';

//security
import { AuthGuard } from './security/auth.guard';

//Fecha en español para datepicker
import { defineLocale } from 'ngx-bootstrap/chronos';
import { esLocale } from 'ngx-bootstrap/locale';
import { ReingresocajasComponent } from './components/reingresocajas/reingresocajas.component';





defineLocale('es', esLocale);

@NgModule({
  declarations: [
    AppComponent,
    PrincipalComponent,
    OrdenproduccionComponent,
    IngresoproduccionComponent,
    ControlproduccionComponent,
    LotesComponent,
    EmpaquesComponent,
    BloqueosComponent,
    PackinglistComponent,
    VencimientosComponent,
    ProductosComponent,
    StockComponent,
    CapacidadComponent,
    PalletsComponent,
    InventariosComponent,
    MovimientosComponent,
    FichasComponent,
    TratosComponent,
    EstadisticaComponent,
    ClientesComponent,
    ProveedoresComponent,
    DespachosComponent,
    ReportesComponent,
    PerfilComponent,
    SalirComponent,
    PermisosComponent,
    PanelcontrolComponent,
    PaginatorComponent,
    AdminTableComponent,
    KeysPipe,
    StockHistoricoComponent,
    SignupComponent,
    SigninComponent,
    EspecificacionComponent,
    TagsComponent,
    PackingEcComponent,
    EntradasComponent,
    SalidasComponent,
    DesconcheComponent,
    UnionsaldoComponent,
    ReimprimiretiquetaComponent,
    DevolucionComponent,
    SolicitudmovimientoComponent,
    EditComponent,
    DetailComponent,
    OrdenespendientesComponent,
    RevisionorderComponent,
    MessageComponent,
    StocknodisponibleComponent,
    StockcomercialComponent,
    ReimprimirpalletComponent,
    RendimientoComponent,
    ReingresocajasComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    routing,
    HttpClientModule,
    ReactiveFormsModule,
    QRCodeModule,
    NgSelectModule,
    BsDropdownModule.forRoot(),
    PopoverModule.forRoot(),
    CollapseModule.forRoot(),
    ModalModule.forRoot(),
    ProgressbarModule.forRoot(),
    AlertModule.forRoot(),
    BsDatepickerModule.forRoot(),
    TimepickerModule.forRoot()
  ],
  providers: [
    appRoutingProviders,
    HttpClientModule,
    ProveedoresService,
    ClientsService,
    ProductionOrderService,
    GlobalService,
    StockService,
    LoadService,
    AuthService,
    CountriesService,
    ProductsService,
    EspecificationService,
    LotesService,
    ClientsSpecificationsService,
    SpeciesService,
    ProductionOrderProductsService,
    TagsService,
    PackingEcService,
    ProductsPropertiesService,
    LocationService,
    PalletsService,
    FilterUrlService,
    UsersService,
    InventoryService,
    DatePipe,
    AuthGuard,
    CodigosSernapescaService,
    AreasService,
    OrdensalidaService,
    OrderstatusService,
    RendimientoService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
        provide: NG_SELECT_DEFAULT_CONFIG,
        useValue: {
            notFoundText: 'Sin resultados.'
        }
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/app.module.ts